import { useEffect } from 'react';
import { queryToObject } from './tools';
import { API } from 'aws-amplify';
import {openSnackbar} from "../store/reducer/snackbar";
import {useDispatch, useSelector} from 'react-redux';
import {handlerSetXeroConnectionsList, handlerSetXeroTenant} from "../store/reducer/xero_connection";

const OAUTH_STATE_KEY = process.env.REACT_APP_OAUTH_STATE_KEY
const OAUTH_RESPONSE = process.env.REACT_APP_OAUTH_RESPONSE;
const apiName = process.env.REACT_APP_ENDPOINT_NAME
const path = process.env.REACT_APP_ENDPOINT_PATH

const checkState = (receivedState) => {
	const state = sessionStorage.getItem(OAUTH_STATE_KEY);
	console.log(state)
	return state === receivedState;
};

const OAuthPopup = (props) => {
	const dispatch = useDispatch();
	const {
		Component = (
			<div style={{ margin: '12px' }} data-testid="popup-loading">
				Loading...
			</div>
		),
	} = props;

	// On mount
	useEffect(() => {
		const payload = queryToObject(window.location.search.split('?')[1]);
		console.log(payload)
		const state = payload && payload.state;
		const error = payload && payload.error;

		// if (!window.opener) {
		// 	throw new Error('No window opener');
		// }

		if (error) {
			window.opener.postMessage({
				type: OAUTH_RESPONSE,
				error: decodeURI(error) || 'OAuth error: An error has occured.',
			});
		} else if (state && checkState(state)) {
			// window.opener.postMessage({
			// 	type: OAUTH_RESPONSE,
			// 	payload,
			// });
			window.postMessage({
				type: OAUTH_RESPONSE,
				payload,
			});
			// call api to get data and redirect user to callinghref key in session storage
			console.log("Going to call API")
			const callinghref = sessionStorage.getItem('callinghref');
			let callback_string = "callback";
			if (callinghref.includes("xero-integrations")){
				callback_string = "callback-xero-integration"
			}
			const selectedSubscription = sessionStorage.getItem('selectedSubscription');
			const myInit = {
                    headers: {
                    },
                    response: true,
                    queryStringParameters: {
                        "code": payload.code,
                        "scope": payload.scope,
                        "state": payload.state,
                        "redirect_uri": process.env.REACT_APP_redirectSignIn + callback_string,
                        "pathname": window.location.pathname,
                        "selectedSubscription": selectedSubscription
                    }
                }
			API.get(apiName, path, myInit)
                    .then(response => {
                        console.log(response);
                        // setData(response); // need to fix
						console.log(JSON.parse(JSON.stringify(response.data)));
						const result = JSON.parse(JSON.stringify(response.data));
						dispatch(handlerSetXeroTenant({
						  xero_tenant:result
					    }));
					    dispatch(handlerSetXeroConnectionsList({
						  connections_list: result.connections_list
					    }))
						window.location.replace(callinghref);
                    })
                    .catch(error => {
                        console.log(error.response);
						dispatch(handlerSetXeroTenant({"xero_tenant":"Incorrect User Signed In to Xero"}));
						window.location.replace(callinghref);
                    })
			// Go back to where user originally signed in.
			// window.location.replace(callinghref);
		} else {
			console.log("ERROR")
			window.opener.postMessage({
				type: OAUTH_RESPONSE,
				error: 'OAuth error: State mismatch.',
			});
		}
	}, []);

	return Component;
};

export default OAuthPopup;